export interface Faq {
  id: string;
  question: string;
  answer: string;
}

export const faqs: Faq[] = [
  {
    id: 'faq-1',
    question: '91视频下载是什么？它安全吗？',
    answer: '91视频是互联网上一个知名的视频内容平台。由于网络上存在大量以"91视频下载"为名义的虚假页面和恶意软件，访问或下载任何相关内容前，请务必确认来源的真实性和可靠性。我们强烈建议用户仅从官方渠道获取信息，并时刻关注网络安全风险。',
  },
  {
    id: 'faq-2',
    question: '如何判断一个下载链接是否安全？',
    answer: '判断下载链接安全性的方法包括：检查网址是否使用HTTPS加密（浏览器地址栏显示锁形图标）、查看域名是否属于官方网站、观察页面设计是否专业无异常、注意是否存在诱导性弹窗或强制下载行为。下载后还应验证文件的数字签名和哈希值。',
  },
  {
    id: 'faq-3',
    question: '遇到虚假91页面应该怎么办？',
    answer: '首先，立即关闭该页面，不要进行任何点击或输入操作。其次，如果已经下载了任何文件，请不要打开，使用安全软件进行扫描后删除。最后，你可以向国家互联网应急中心（CNCERT）或相关平台举报该虚假页面，帮助更多人免受其害。',
  },
  {
    id: 'faq-4',
    question: '我的个人信息会被虚假页面窃取吗？',
    answer: '如果你在虚假页面上输入了任何信息（包括账号、密码、手机号等），那么这些信息很可能已经被攻击者获取。建议立即修改所有相关账号的密码，开启双因素认证，并密切关注相关账号的异常活动。如果涉及银行卡信息，应第一时间联系银行冻结账户。',
  },
  {
    id: 'faq-5',
    question: '91视频有官方应用吗？如何辨别真假？',
    answer: '辨别应用真伪的最佳方式是溯源至官方网站或官方认证的应用商店。不要在第三方下载站下载声称是"官方版本"的应用。真伪辨别可以从数字签名、文件大小、安装界面设计、权限请求是否合理等多个维度进行综合判断。',
  },
  {
    id: 'faq-6',
    question: '使用91视频下载相关服务是否合法？',
    answer: '任何互联网服务的使用都应当遵守所在地区的法律法规。中国法律法规对网络内容有明确规定，用户在使用任何互联网服务时都应自觉遵守相关规定，不传播、不下载违法违规内容。具体法律问题建议咨询专业法律人士。',
  },
  {
    id: 'faq-7',
    question: '如何保护自己免受恶意下载的侵害？',
    answer: '保护措施包括：安装并保持更新可靠的安全防护软件、仅从官方渠道下载应用、下载后验证文件完整性、不随意授予应用不必要的权限、定期备份重要数据、保持操作系统和应用的及时更新、以及提高自身的网络安全意识。',
  },
  {
    id: 'faq-8',
    question: '发现恶意下载网站后应该怎么做？',
    answer: '你可以通过以下途径举报：向国家互联网应急中心（CNCERT）提交举报、通过12321网络不良与垃圾信息举报受理中心举报、向浏览器厂商报告（以便将其标记为危险网站）、在相关安全社区分享经验提醒他人。同时，如果在使用过程中遭受了经济损失，应及时向公安机关报案。',
  },
];